import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
import { DomainName } from "./domain_name";
import { id_ntQWAC } from "./oids";
export const id_DomainNameTechnicalOperator = `${id_ntQWAC}.4`;
let DomainNameTechnicalOperator = class DomainNameTechnicalOperator extends DomainName {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, Name.prototype);
    }
};
DomainNameTechnicalOperator = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], DomainNameTechnicalOperator);
export { DomainNameTechnicalOperator };
